import axios from "axios";
import { BASE_URL } from "../Utlils";

// Generate a new API key
export const generateApiKey = async (keyName) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/api-key`, { keyName });
    return data;
  } catch (error) {
    console.log("Unable to generate API key");
    throw error;
  }
};

// Get all API keys for the organization
export const getAllApiKeys = async () => {
  try {
    const { data } = await axios.get(`${BASE_URL}/api-key`);
    return data;
  } catch (error) {
    console.log("Unable to get API keys");
    throw error;
  }
};

// Revoke an API key
export const revokeApiKey = async (keyId) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/api-key/${keyId}/revoke`);
    return data;
  } catch (error) {
    console.log("Unable to revoke API key");
    throw error;
  }
};

// Regenerate an API key
export const regenerateApiKey = async (keyId) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/api-key/${keyId}/regenerate`);
    return data;
  } catch (error) {
    console.log("Unable to regenerate API key");
    throw error;
  }
};
